import { z } from "zod";

// The caller's canonical identity plus the server's admin verdict. `isAdmin`
// reflects the Einstein.Admin app role as the API sees it; the UI uses it to
// decide which administrative affordances to render. It is never an
// authorization decision on its own — every mutation re-checks server-side.
export const CurrentUserSchema = z.object({
    userId: z.string(),
    displayName: z.string(),
    isAdmin: z.boolean(),
});

export type CurrentUser = z.infer<typeof CurrentUserSchema>;
